const QUERY_SELECTORS = {
  HIDE_ON_AUTH: '[data-hide-on-authenticated]',
  SHOW_ON_AUTH: '[data-show-on-authenticated]',
  HIDE_ON_WEB: '[data-hide-on-web]',
  HIDE_ON_APP: '[data-hide-on-app]'
}

function init() {
  window.$(document).on('page:load', function () {
    const isLoggedIn = window._currentUserToken || (window.localStorage && localStorage.getItem('radio-auth-token'));
    const isInApp = (window.webkit && window.webkit.messageHandlers) || window.Android;

    if (isLoggedIn) {
      hideElements(QUERY_SELECTORS.HIDE_ON_AUTH)
      showElements(QUERY_SELECTORS.SHOW_ON_AUTH)
    } else {
      hideElements(QUERY_SELECTORS.SHOW_ON_AUTH)
      showElements(QUERY_SELECTORS.HIDE_ON_AUTH)
    }

    if (isInApp) {
      hideElements(QUERY_SELECTORS.HIDE_ON_APP)
      showElements(QUERY_SELECTORS.HIDE_ON_WEB)
    } else {
      hideElements(QUERY_SELECTORS.HIDE_ON_WEB)
      showElements(QUERY_SELECTORS.HIDE_ON_APP)
    }
  });
}

function hideElements(querySelector) {
  document.querySelectorAll(querySelector).forEach(el => el.classList.add('hidden'))
}

function showElements(querySelector) {
  document.querySelectorAll(querySelector).forEach(el => el.classList.remove('hidden'))
}

export default init;
